<template>
    <div>
        <div class="list-campaign"
            v-if="isLoaded && isHaveItem">
            <campaign-item
                v-for="(campaign, k) in campaigns"
                :key="k"
                :index="k"
                :lbl="lbl"
                :campaign="campaign"
                @clickCampaign="clickCampaign($event)"
            ></campaign-item>
            
        </div>
        
        <div v-if="!isHaveItem && isLoaded" class="list-no-campaign">
            --ไม่พบแคมเปญ--
        </div>
        <div class="footer-campaign-list empty-footer-campaign-list"> <p class="text-sub-head" @click="clickUnSubScribe()"><u>ยกเลิกการรับข้อมูลข่าวสาร ?</u></p> </div>
        <modal view="campaign-list-components"
            :busModal="busModal"></modal>
    </div>
</template>
<script>
import Vue from "vue";
import Account from "@/helper/AccountHelper.js";
//component
import CampaignItem from "@/components/campaign/list/CampaignItem.vue";
//service
import BzbsCampaign from "@/service/BzbsCampaign.js";
//modal

import Modal from '@/components/modal/Modal.vue';
import { TrackingService } from "@/helper/TrackingHelper.js";

/**
 * property
 * @property {object} lbl Text for component.
 * @property {boolean} isLoading Loading status.
 * @property {object} listConfig Configuration for call api.
 * @property {object} filterConfig Filter configuration for call api.
 * @property {object} busEvent Bus event for parent component.
 * method
 * @method getList Get list of campaign for api.
 * @method initialLoadMore Initial scroll event to load more campaign.
 * @method loadMore Load more campaigns.
 * utility
 * @method hideLoading Hide loading screen.
 * @method showLoading Show loading screen.
 * bus event.
 * @event switchLang Reinitial campaign list with new language setup.
 * @event reInitList Reinitail campaign list.
 * @event toggleLoading Toggle loading value.
 */
export default {
    name: "CampaignList",
    components: {
        CampaignItem,
        Modal
    },
    props: {
        lbl: Object,
        isLoading: Boolean,
        initListConfig: Object,
        initFilterConfig: Object,
        busEvent: Object,
    },
    data: function() {
        return {
            campaigns: [],
            isLoaded: false,
            isHaveItem: false,
            listConfig: {},
            filterConfig: {},

            busModal: new Vue(),
            tracking: new TrackingService(this),
        };
    },
     mounted: function() {
        this.busEvent.$on("switchLang", this.switchLang);
        this.busEvent.$on("reInitList", this.reInitialList);
    },
    created: function() {
        this.listConfig = this.initListConfig;
        this.filterConfig = this.initFilterConfig;

        this.getList();
        this.initialLoadMore();
    },
    methods: {
        //initial
        initialLoadMore: function() {
            window.onscroll = () => {
                // 100 คือระยะก่อนถึงจุดล่างสุดของ page
                var scrollOffSet = 100;
                var pageHeight = Math.max(
                    window.pageYOffset,
                    document.documentElement.scrollTop,
                    document.body.scrollTop
                );
                var bottomOfWindow =
                    pageHeight + window.innerHeight >
                    document.documentElement.offsetHeight - scrollOffSet;
                if (bottomOfWindow) {
                    this.loadMore();
                }
            };
        },
        //event
        //method
        getList: function() {
            if (!this.listConfig.strConfigList) return;
            
           
            var strBzbsToken = Account.getToken();
            BzbsCampaign.apiGetCampaign(strBzbsToken, this.listConfig, null)
                .then(campaigns => {

                    
                    this.listConfig.intSkip += this.listConfig.defaultTopAmount;
                    //check is there are more campaign.
                    if (campaigns &&
                        campaigns.length < this.listConfig.defaultTopAmount)
                        this.listConfig.isSeeMoreEnable = false;

                    //reinitialize list if no skip.
                    if (this.listConfig.intSkip ==
                        this.listConfig.defaultTopAmount)
                        this.campaigns = [];

                    for (var campaign of campaigns) {
                        //TODO: Add GA Tracking.
                        this.campaigns.push(campaign);
                    }
                    //this.campaigns.length = 0;
                    this.isLoaded = true;
                    this.isHaveItem = this.campaigns.length > 0
                        ? true
                        : false;

                    this.hideLoading();
                    console.log(this.campaigns);
                }).catch(error => {

                    this.isLoaded = true;
                    this.isHaveItem = false;
                    this.hideLoading();
                    console.log(error);

                    if (!error.response) { 
                        this.showErrorInternet();
                    }
                    
                });
        },
        loadMore: function() {
            if (!this.listConfig.isSeeMoreEnable) return;
            if (this.showLoading()) return;

            setTimeout(() => {
                this.getList();
            }, 500);
        },
        resetLoaded: function () {
            this.campaigns = [];
            this.isLoaded = false;
            this.isHaveItem = false;
        },
        reInitialList: function (data) {
            this.resetLoaded();
            this.listConfig = data.listConfig;
            this.filterConfig = data.filterConfig;

            this.getList();
        },
        //utilities
        hideLoading: function () {
            this.toggleLoading(false);
            this.busModal.$emit('hideLoadingModal', {});
        },
        showLoading: function () {
            if (this.isLoading) return true;

            this.toggleLoading(true);
            this.busModal.$emit('showLoadingModal', {});

            return false;
        },
        //bus event
        switchLang: function() {
            this.resetLoaded();
            this.getList();
        },
        toggleLoading: function (isLoading) {
            this.$emit('toggleLoading', isLoading);
        },
        clickCampaign: function (campaign) {
            this.$emit('clickCampaign', campaign);
        },
        clickUnSubScribe: function () {
            
            this.tracking.event("Unregis_flow", "click_unregis_botton");
            this.$emit('clickUnSubScribe');
        },
        showErrorInternet: function () {
            var configModal = {
                title: null,
                message: "พบปัญหาการเชื่อมต่อ",
                strBtnOk: "ปิด",
                tag: "nointernet",
            };
            this.busModal.$emit('showAlertModal', configModal);
        }
    }
};
</script>
<style lang="scss" scoped>
@import "@/style/base/component/campaign/list/campaignlist.scss";
</style>
